import type {
  BrandCode,
  CaptureState,
  Payment,
  PaymentSearchByField,
  PaymentSortDir,
  PaymentSortField,
} from '@models/payments';
import { apiClient } from '@api/client';

export type DashboardPaymentTypeFilter = 'standard' | 'debt_collection' | 'recurring_recovery';

export type DashboardPaymentStatusFilter = 'pending' | 'failed' | 'completed' | 'refunded';

export type GetPaymentsParams = {
  page: number;
  limit: number;
  fromDate?: string;
  toDate?: string;
  status?: DashboardPaymentStatusFilter;
  paymentType?: DashboardPaymentTypeFilter;
  brandCode?: BrandCode;
  searchQuery?: string;
  searchBy?: PaymentSearchByField;
  captureState?: CaptureState;
  sortBy?: PaymentSortField;
  sortOrder?: PaymentSortDir;
};

export type PaymentsMeta = {
  page: number;
  limit: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
};

export type PaymentsResponse = {
  data: Payment[];
  meta: PaymentsMeta;
};

export async function getPayments(params: GetPaymentsParams): Promise<PaymentsResponse> {
  const { data } = await apiClient.get<PaymentsResponse>('/dashboard-payments', { params });
  return data;
}

export type CapturePaymentParams = {
  paymentId: string;
  /** Part of the payment's primary key, so the API can find it without scanning every partition. */
  paymentCreatedAt: string;
};

export type CapturePaymentResponse = {
  paymentId: string;
  captured: boolean;
  captureState: CaptureState;
};

export async function capturePayment(
  params: CapturePaymentParams,
): Promise<CapturePaymentResponse> {
  const { data } = await apiClient.post<CapturePaymentResponse>(
    '/dashboard-payments/capture',
    params,
  );
  return data;
}
